var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live-desc"},[_c('h3',[_vm._v("听课指南")]),(!_vm.liveDetail.show_guide)?_c('pre',[_vm._v(_vm._s(_vm.defaultText))]):_c('pre',[_vm._v(_vm._s(_vm.liveDetail.guide))])])}
var staticRenderFns = []

export { render, staticRenderFns }